export default {
  basicLogoInfo: {},
  // logo列表
  logoList: [],
  logoTotalCount: '',
  imgList: [],
  ossInfo: {},
  uploadState: '',
  ossUrl: '',
  saveState: '',
  logoInfo: {},
  handleFreezeState: {}
}



// WEBPACK FOOTER //
// ./src/store/logo/state.js